<template>
  <template v-if="!!formInputs?.form?.gsensor">
    <v-card class="my-4 pa-4">
      <v-card-title class="headline">
        {{ i18n.global.t('pages.vehicles.form.iniFileSetting.gSensor.title') }}
      </v-card-title>
      <v-card-text>
        <div class="row mr-3 v-theme--light">
          <template v-for="(title, key) in keys" v-bind:key="key">
            <SettingFormInput
              :label="title"
              v-model="form[key]"
              :isShow="formFieldOptions[key].isShow"
              :isRequired="formFieldOptions[key].isRequired"
              :formInputs="formInputs"
              :readonly="(isReadonly(key) || isInstallationOffice)"
              :errors="formFieldOptions[key].errors"
            />
          </template>
          <div
              class="col-6"
              v-if="formInputs?.form?.gsensor?.acceleration != undefined"
          >
            <v-select
              class="small mt-2"
              :label="i18n.global.t('pages.vehicles.form.iniFileSetting.gSensor.acceleration')"
              v-model="form.acceleration"
              :items="accelerationList"
              :error-messages="errors[errorKeyPrefix + '.acceleration']"
              :clearable="false"
              :disabled="isInstallationOffice"
            />
          </div>
          <div
              class="col-6"
              v-if="formInputs?.form?.gsensor?.acceleration_forward != undefined"
          >
            <v-select
              class="small mt-2"
              :label="i18n.global.t('pages.vehicles.form.iniFileSetting.gSensor.accelerationForward')"
              v-model="form.acceleration_forward"
              :items="accelerationForwardList"
              item-title="label"
              item-value="code"
              :disabled="(form.acceleration == 0 || isInstallationOffice)"
              :error-messages="errors[errorKeyPrefix + '.acceleration_forward']"
              :clearable="false"
              @update:modelValue="(value) => handleCustomAccelerationChange('forward', value)"
            />
          </div>
          <div
              class="col-6"
              v-if="formInputs?.form?.gsensor?.acceleration_backward != undefined"
          >
            <v-select
              class="small mt-2"
              :label="i18n.global.t('pages.vehicles.form.iniFileSetting.gSensor.accelerationBackward')"
              v-model="form.acceleration_backward"
              :items="accelerationBackwardList"
              item-title="label"
              item-value="code"
              :disabled="(form.acceleration == 0 || isInstallationOffice)"
              :error-messages="errors[errorKeyPrefix + '.acceleration_backward']"
              :clearable="false"
              @update:modelValue="(value) => handleCustomAccelerationChange('backward', value)"
            />
          </div>
        </div>
      </v-card-text>
    </v-card>
    <IniFileGSensorSettingCustomModal
      :label="i18n.global.t('pages.vehicles.form.iniFileSetting.gSensor.accelerationForward')"
      v-model="showCustomAccelerationForwardInputModal"
      v-model:customValue="customAccelerationForward"
      @saveCustomValue="saveCustomAcceleration('forward')"
      @clearCustomValue="clearCustomAcceleration('forward')"
    />
    <IniFileGSensorSettingCustomModal
      :label="i18n.global.t('pages.vehicles.form.iniFileSetting.gSensor.accelerationBackward')"
      v-model="showCustomAccelerationBackwardInputModal"
      v-model:customValue="customAccelerationBackward"
      @saveCustomValue="saveCustomAcceleration('backward')"
      @clearCustomValue="clearCustomAcceleration('backward')"
    />
  </template>
</template>

<script>
import SettingFormInput from '@/components/VehicleFormParts/SettingFormInput.vue';
import IniFileGSensorSettingCustomModal from '@/components/VehicleFormParts/IniFileGSensorSettingCustomModal.vue';
import i18n from '@/lang/i18n';

export default {
  setup() {
    return {
      i18n
    }
  },
  props: {
    modelValue: {},
    formInputs: {},
    selectDefault: {
      type: Boolean,
      default: false,
    },
    errors: {},
    isInstallationOffice: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {},
      readonlyInputs: [],
      errorKeyPrefix: 'initial_params.gsensor',
      keys: {
        horizontal: i18n.global.t('pages.vehicles.form.iniFileSetting.gSensor.horizontal'),
        backward: i18n.global.t('pages.vehicles.form.iniFileSetting.gSensor.backward'),
        forward: i18n.global.t('pages.vehicles.form.iniFileSetting.gSensor.forward'),
      },
      accelerationList: [0, 1],
      accelerationForwardList: [
        { code: 'custom', label: 'カスタム' },
        { code: '18.0', label: '18.0' },
        { code: '16.2', label: '16.2' },
        { code: '14.4', label: '14.4' },
        { code: '12.6', label: '12.6' },
        { code: '10.8', label: '10.8' },
        { code: '9.0', label: '9.0' },
        { code: '7.2', label: '7.2' },
        { code: '5.4', label: '5.4' },
        { code: '3.6', label: '3.6' },
        { code: '3.2', label: '3.2' },
        { code: '2.9', label: '2.9' },
        { code: '2.5', label: '2.5' },
        { code: '2.2', label: '2.2' },
        { code: '1.8', label: '1.8' },
      ],
      accelerationBackwardList: [
        { code: 'custom', label: 'カスタム' },
        { code: '18.0', label: '18.0' },
        { code: '16.2', label: '16.2' },
        { code: '14.4', label: '14.4' },
        { code: '12.6', label: '12.6' },
        { code: '10.8', label: '10.8' },
        { code: '9.0', label: '9.0' },
        { code: '7.2', label: '7.2' },
        { code: '5.4', label: '5.4' },
        { code: '3.6', label: '3.6' },
        { code: '3.2', label: '3.2' },
        { code: '2.9', label: '2.9' },
        { code: '2.5', label: '2.5' },
        { code: '2.2', label: '2.2' },
        { code: '1.8', label: '1.8' },
      ],
      showCustomAccelerationForwardInputModal: false,
      customAccelerationForward: null,
      showCustomAccelerationBackwardInputModal: false,
      customAccelerationBackward: null
    };
  },
  methods: {
    getShowAndRequiredAndErrors(parentKey, formKeys) {
      if (!this.formInputs?.form[parentKey]) {
        return {
          'isShow': false,
          'isRequired': false,
          'errors': null
        };
      }

      const keys = Object.keys(this.formInputs.form[parentKey]);

      const result = formKeys.map(formKey => {
        return {
          'isShow': keys.includes(formKey),
          'isRequired': !!this.formInputs.form[parentKey][formKey]?.required,
          'errors': this.errors[this.errorKeyPrefix + '.' + formKey]
        };
      });

      return {
        'isShow': result.every(item => item.isShow),
        'isRequired': result.every(item => item.isRequired),
        'errors': result.map(item => item.errors).filter(error => error)
      };
    },
    isReadonly(key) {
      let readonlyStatus = true

      if (this.form.acceleration == 0) {
        readonlyStatus = false
      } else if (this.form.acceleration == 1) {
        if (key == 'horizontal') {
          readonlyStatus = false
        }
      }

      return readonlyStatus;
    },
    handleCustomAccelerationChange(key, value) {
      if (value === 'custom' && key === 'forward') {
        this.showCustomAccelerationForwardInputModal = true;
      } else if (value === 'custom' && key === 'backward') {
        this.showCustomAccelerationBackwardInputModal = true;
      }
    },
    saveCustomAcceleration(key) {
      if (key === 'forward') {
        const customValue = parseFloat(this.customAccelerationForward).toFixed(1);
        this.form.acceleration_forward = customValue;
        if (isNaN(customValue)) {
          this.form.acceleration_forward = null;
        }
      } else if (key === 'backward') {
        const customValue = parseFloat(this.customAccelerationBackward).toFixed(1);
        this.form.acceleration_backward = customValue;
        if (isNaN(customValue)) {
          this.form.acceleration_backward = null;
        }
      }
    },
    clearCustomAcceleration(key) {
      if (key === 'forward') {
        this.form.acceleration_forward = null;
      } else if (key === 'backward') {
        this.form.acceleration_backward = null;
      }
    }
  },
  computed: {
    formFieldOptions() {
      const parentKey = 'gsensor'

      const options = {
        machineId: this.getShowAndRequiredAndErrors(parentKey, ['machine_id']),
      };

      Object.keys(this.keys).forEach(key => {
        options[key] = this.getShowAndRequiredAndErrors(parentKey, [key]);
      });

      return options;
    },
  },
  watch: {
    modelValue: {
      handler() {
        this.form = this.modelValue;
      },
    },
    formInputs: {
      handler() {
        if (!this.formInputs?.form?.gsensor) return;
        const key = Object.keys(this.formInputs.default_params)[0];
        this.readonlyInputs = Object.keys(
          this.formInputs.default_params[key]?.parameters?.gsensor ?? []
        );
      },
    },
    form: {
      handler() {
        this.$emit('update:modelValue', this.form);
      },
      deep: true,
    },
    'form.acceleration': {
      handler() {
        if (this.form.acceleration == '0') {
          this.form.acceleration_backward = null;
          this.form.acceleration_forward = null;
        } else if (this.form.acceleration == '1') {
          this.form.backward = null;
          this.form.forward = null;
        }
      },
    },
  },
  components: {
    SettingFormInput,
    IniFileGSensorSettingCustomModal
  },
};
</script>

<style scoped>
.headline {
  font-size: 24px;
  font-weight: bold;
  color: #0088a6;
}
</style>
